"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Group = void 0;
var _react = _interopRequireDefault(require("react"));
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _Item = require("./Item");
require("./Group.scss");
const Group = _ref => {
  let {
    title,
    items,
    onLinkClick,
    className
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-AccountMenu-Group', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, Array.isArray(items) && items.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement("h4", {
    className: "cds-AccountMenu-GroupTitle"
  }, title), /*#__PURE__*/_react.default.createElement("ul", {
    className: "cds-AccountMenu-GroupList"
  }, items.map((item, index) => /*#__PURE__*/_react.default.createElement(_Item.Item, {
    title: item.title,
    href: item.href,
    icon: item.icon,
    isActive: item.isActive,
    hasBadge: item.hasBadge,
    onLinkClick: onLinkClick,
    key: (0, _key.createKey)(index, 'item')
  })))));
};
exports.Group = Group;
//# sourceMappingURL=Group.js.map